<template>
  <div class="divider"></div>
</template>

<style>
  .divider {
    @apply border-b;
  }
</style>
